import { useSecao } from "./use-secao";
import { SecaoView } from "./view-secao";
import type { SecaoProps } from "./types-secao";

export function Secao(props: SecaoProps) {
  const vm = useSecao(props);

  return <SecaoView {...props} {...vm} />;
}

export type * from "./types-secao";
